import styled from "styled-components";
import { when } from "../styles/theme.js";

export const SectionTitle = styled.h2`
  font-size: 3.6rem;
  color: ${(props) => props.color || props.theme.colors.darkBlue};
  margin: 0;

  ${when("lg")} {
    font-size: 4.8rem;
  }
`;
